import React from "react";

const Hero = () => (
  <section className=" text-white py-20 md:py-28 flex justify-center items-center">
    <div className="w-full max-w-4xl bg-gradient-to-r from-brandcolour to-indigo-600 rounded-lg p-8 md:p-16 text-center">
      {/* Hero Heading */}
      <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
        Empowering Your Business with Cutting-Edge IT Solutions
      </h1>
      {/* Hero Subtext */}
      <p className="text-lg md:text-xl mt-6">
        Transform your business with innovative technology tailored to your unique needs.
      </p>
    </div>
  </section>
);

export default Hero;
